import axios from 'axios';
import { BASE_URL } from './apiEndpoints';
import requestInterceptor from './requestInterceptor';
import { errorResponseHandler, successResponseHandler } from './responseHandler';

const axiosInstanceOptions = {
  baseURL: BASE_URL,
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
  },
};

const axiosInstance = axios.create(axiosInstanceOptions);
axiosInstance.interceptors.request.use(requestInterceptor);

export const httpRequest = {
  get: (url, config) =>
    axiosInstance
      .get(url, config)
      .then(successResponseHandler)
      .catch(errorResponseHandler),
  post: (url, data, config) =>
    axiosInstance
      .post(url, data, config)
      .then(successResponseHandler)
      .catch(errorResponseHandler),
  put: (url, data, config) =>
    axiosInstance
      .put(url, data, config)
      .then(successResponseHandler)
      .catch(errorResponseHandler),
  delete: (url, config) =>
    axiosInstance
      .delete(url, config)
      .then(successResponseHandler)
      .catch(errorResponseHandler),
};
